import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useAuth } from '../../../../app/modules/auth'

const NotFound: FC = () => {
  const {currentUser, logout} = useAuth()

    const navigate = useNavigate()

    const handleLogout = async () => {
    await logout()
    navigate('/auth') // or whatever your login route is
  }

  return (
    <>
      {/* begin::Title */}
      <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>Oops!</h1>
      {/* end::Title */}

      {/* begin::Text */}
      <div className='fw-semibold fs-6 text-gray-500 mb-7'>We can't find that page.</div>
      {/* end::Text */}

      {/* begin::Illustration */}
      <div className='mb-3'>
        <img
          src={toAbsoluteUrl('/media/auth/404-error.png')}
          className='mw-100 mh-300px theme-light-show'
          alt=''
        />
        <img
          src={toAbsoluteUrl('/media/auth/404-error-dark.png')}
          className='mw-100 mh-300px theme-dark-show'
          alt=''
        />
      </div>
      {/* end::Illustration */}

      {/* begin::Link */}
      <div className='mb-0'>
        <button onClick={handleLogout} className='btn btn-sm btn-primary'>
          Return Login
        </button>
      </div>
      {/* end::Link */}
    </>
  )
}

export { NotFound }

